module.exports = __webpack_public_path__ + "static/media/createMeetTam.99700a38.jpg";